import { Outlet, Link } from "react-router-dom";

const Layoutlogin = () => {
  return (
    <>
      <Outlet />
    </>
  )
};

export default Layoutlogin;